import $ from 'jquery';
import 'fancybox/dist/js/jquery.fancybox';

import Component from '../Component';

export default class Popup extends Component {

  /**
   * @param {import('../ThemeBase').default} theme
   * @param {HTMLElement} element
   */
  constructor(theme, element) {
    super(theme, element)

    this.STORAGE_KEY = 'wetheme-popup';
    this.isFullscreen = this.element.dataset.desktopType === "fullscreen";
    this.popupSkipDays = parseInt(this.element.dataset.popupTime, 10);
    this.popupDelay = parseInt(this.element.dataset.popupDelay, 10);
    this.testMode = this.element.dataset.popupTestMode === 'true';

    if (this.testMode) {
      // popup is in test mode - will show immediately in editor and on live site
      this.show();
    } else if (this.isExpiredOrNotSet()) {
      // popup item in localStorage is expired or was not set, show popup this time
      setTimeout(() => {
        this.setExpiry(this.popupSkipDays);
        this.show();
      }, 1000 * this.popupDelay);
    }

    this.element.querySelector('.popup--close-btn').addEventListener('click', () => {
      this.element.classList.remove('visible');
    });
  }

  isExpiredOrNotSet = () => {
    var expired = true;
    var popupInfo = window.localStorage.getItem(this.STORAGE_KEY);
    if (popupInfo) {
      try {
        var expiry = Date.parse(JSON.parse(popupInfo).expiry);
        if (expiry > Date.now()) {
          expired = false;
        }
      } catch (e) {
        console.warn('Unable to read popup expiry date', e);
      }
    }
    return expired;
  }

  setExpiry = (days) => {
    var expiry = new Date(Date.now() + days * 24 * 60 * 60 * 1000);
    try {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify({
        expiry: expiry.toISOString(),
      }));
    } catch (e) {
      console.warn('Unable to set popup expiry:', e);
    }
  }

  onWindowResize = ({ width }) => {
    // @ts-ignore
    var isFullscreenOpen = $.fancybox.isOpen;
    if (width < 769) {
      if (isFullscreenOpen) {
        // switch from fullscreen to slide-up
        $.fancybox.close();
        this.showSlideUp();
      }
    } else {
      if (this.element.classList.contains('visible') && this.isFullscreen) {
        this.element.classList.remove('visible');
        this.showFullscreen();
      }
      if (isFullscreenOpen) {
        $.fancybox.reposition();
      }
    }
  }

  show = () => {
    if (this.theme.getWindowWidth() < 769) {
      $.fancybox.close();
      this.showSlideUp();
    } else {
      if (this.isFullscreen){
        this.element.classList.remove('visible');
        this.showFullscreen();
      } else {
        this.showSlideUp();
      }
    }
  }

  showSlideUp = () => {
    document.querySelector('#slide-up').removeAttribute("style");
    document.querySelector('#popup').classList.add('slide-up');
    document.querySelector('#popup').classList.add('visible');
  }

  showFullscreen = () => {
    document.querySelector('#popup').classList.add('fullscreen');
    document.querySelector('#fullscreen').removeAttribute("style");

    $.fancybox({
      // @ts-ignore
      'autoScale': true,
      'transitionIn': 'elastic',
      'transitionOut': 'elastic',
      'speedIn': 500,
      'speedOut': 300,
      'autoDimensions': true,
      'centerOnScroll': true,
      'href': '#popup #fullscreen',
      'wrapCSS': 'fullscreen-popup-fancybox',
      tpl: {
        closeBtn: '<div class="popup--close fancybox-close" tabindex="0"></div>'
      }
    });
  }
}
